import { PlusOutlined, QrcodeOutlined } from "@ant-design/icons";
import { Button, message, Select, Tooltip } from "antd";
import _ from "lodash";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { apiRequest } from "../../api";
import apiPaths from "../../api/paths";
import DynamicTable from "../../components/DynamicTable";
import VehicleRouteModal from "./components/VehicleRouteModal";
import { createFileName, useScreenshot } from "use-react-screenshot";
import QRCode from "react-qr-code";
import CryptoJS from "crypto-js";
import images from "../../assets/images";

function VehicleRoutes() {
  const [type, setType] = useState("Buggy");
  const [editingKey, setEditingKey] = useState(null);
  const [vehicleRoutes, setVehicleRoutes] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [showVehicleRouteModal, setShowStationModal] = useState(false);
  const [qrCodeData, setQrCodeData] = useState(null);
  const [image, takeScreenshot] = useScreenshot();
  const ref = useRef(null);

  const download = (image, { name = "img", extension = "png" } = {}) => {
    const a = document.createElement("a");
    a.href = image;
    a.download = createFileName(extension, name);
    a.click();
  };

  useEffect(() => {
    fetchVehicles();
  }, []);

  const fetchVehicles = async () => {
    const res = await apiRequest({
      path: apiPaths.vehicles,
    });
    if (!res.error) {
      setVehicles(res.results);
    }
  };

  useEffect(() => {
    fetchVehicleRoutes(type);
  }, [type]);

  const fetchVehicleRoutes = async (type) => {
    const res = await apiRequest({
      path: apiPaths.vehicleRoutes + `?route_type=${type}`,
    });
    if (!res.error) {
      let itemsObj = res.results.reduce((items, item) => {
        items[item.id + "r"] = item;
        return items;
      }, {});
      setVehicleRoutes(itemsObj);
    } else {
      message.error(res.error_description);
    }
  };

  const getImage = (id) => {
    return takeScreenshot(ref.current).then((img) =>
      download(img, { name: "route_" + id, extension: "png" })
    );
  };

  const handleGenerateQRCode = (data) => {
    let id_vehicle = CryptoJS.MD5(
      `id_vehicle#@#@${data.id_vehicle}`
    ).toString();
    let id = CryptoJS.MD5(`id#@#@${data.id}`).toString();
    setQrCodeData({ codeData: { id_vehicle, id, type: "route" }, data });
    setTimeout(() => {
      getImage(data.vehicle.name + "_" + data.from_and_to);
    }, 1000);
  };

  const COLUMNS = [
    {
      title: "Vehicle",
      dataIndex: "vehicle.name",
      width: "120px",
      filterType: "search",
      fixed: "left",
    },
    {
      title: "From and To",
      dataIndex: "from_and_to",
      width: "150px",
      render: (value, record) => {
        if (type == "Barc") {
          return (
            <div style={{ fontSize: 11 }}>
              {`from: ${record.start_dock?.name}`}
              <br />
              {`to: ${record.end_dock?.name}`}
            </div>
          );
        }
        return value;
      },
    },
    {
      title: "Charges",
      dataIndex: "charges",
      filterType: "search",
      width: "100px",
    },
    {
      title: "Created Date",
      dataIndex: "date_create",
      width: "150px",
      filterType: "date",
      render: (value) => {
        return <div>{value && moment(value).format("DD-MM-YYYY HH:mm")}</div>;
      },
    },

    {
      title: "Qr Code",
      dataIndex: "qrcode",
      width: "50px",
      render: (text, record) => (
        <Tooltip title="download QR code">
          <Button
            onClick={() => handleGenerateQRCode(record)}
            type="link"
            style={{ marginLeft: 10 }}
          >
            <QrcodeOutlined style={{ fontSize: 16 }} />
          </Button>
        </Tooltip>
      ),
    },
  ];

  const handleRowCanceled = () => {
    setShowStationModal(false);
  };

  const handleRowEdit = (idx) => {
    setEditingKey(idx);
    setShowStationModal(true);
  };

  const handleRowSave = async (row) => {
    if (editingKey == null) {
      const res = await apiRequest({
        path: apiPaths.vehicleRoutes,
        method: "POST",
        data: row,
      });
      if (res.error) {
        message.error(res.error_description);
        return;
      }
      setVehicleRoutes({ [res.id + "r"]: res, ...vehicleRoutes });
      setShowStationModal(false);
      return;
    }
    let key = editingKey;
    const res = await apiRequest({
      path: apiPaths.vehicleRoutes + `/${key}`,
      method: "PUT",
      data: row,
    });
    if (res.error) {
      message.error(res.error_description);
      return;
    }
    vehicleRoutes[editingKey + "r"] = res;
    setVehicleRoutes({ ...vehicleRoutes });
    setEditingKey(null);
    setShowStationModal(false);
  };

  return (
    <div style={{ height: "80vh" }}>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
        }}
      >
        <div>
          {"Showing: "}
          <Select
            value={type}
            style={{ width: 160 }}
            onChange={(value) => {
              setType(value);
            }}
          >
            <Select.Option key={"Buggy"}>Buggy Routes</Select.Option>
            <Select.Option key={"Barc"}>Barc Routes</Select.Option>
          </Select>
        </div>
        <Tooltip title="Add Vehicle Route">
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingKey(null);
              setShowStationModal(true);
            }}
          />
        </Tooltip>
      </div>
      <div style={{ height: "90%", marginTop: 30 }}>
        <DynamicTable
          dataSource={Object.values(vehicleRoutes)}
          columns={COLUMNS}
          scroll={{
            // x: 2250,
            y: "65vh",
          }}
          editHandler={(record) => handleRowEdit(record.id)}
          pagination={false}
        />
      </div>
      {qrCodeData ? (
        <div
          style={{
            position: "absolute",
            right: -500,
            backgroundColor: "#fff",
            alignItems: "center",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            width: 450,
            height: 600,
          }}
          ref={(_ref) => (ref.current = _ref)}
        >
          <img
            src={images.qrCodeFrameImg}
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <div
            style={{
              fontSize: 30,
              fontWeight: "bold",
              position: "absolute",
              color: "#fff",
              top: "8%",
              left: "8%",
            }}
          >
            {qrCodeData.data.id_vehicle}
          </div>
          <div
            style={{
              fontSize: 24,
              fontWeight: "bold",
              position: "absolute",
              color: "#fff",
              bottom: 10,
            }}
          >
            {`SCAN THIS CODE TO PAY ME ₹${qrCodeData.data.charges}.`}
          </div>
          <div
            style={{
              height: "60%",
              width: "75%",
              position: "absolute",
              bottom: "10%",
            }}
          >
            <QRCode
              style={{ width: "100%", height: "100%" }}
              value={JSON.stringify(qrCodeData.codeData)}
            />
          </div>
          {/* </div> */}
        </div>
      ) : null}
      {showVehicleRouteModal ? (
        <VehicleRouteModal
          open={showVehicleRouteModal}
          onSave={handleRowSave}
          routeType={type}
          onCancel={handleRowCanceled}
          data={vehicleRoutes[editingKey + "r"]}
          isUpdate={editingKey != null}
          vehicles={vehicles}
        />
      ) : null}
    </div>
  );
}

export default VehicleRoutes;
